import React from 'react';
import { Box } from 'components/common_v2/layouts';
import { HeadingLarge, HeadingSmall } from 'components/common_v2/typography';
import { WoahNo as WoahNoIcon } from './components';

export const Error500 = () => (
  <Box flex="1">
    <Box flex="1" alignItems="center" justifyContent="center">
      <div style={{ paddingRight: '28px' }}>
        <HeadingLarge>Error 500</HeadingLarge>
        <HeadingSmall>Something went wrong...</HeadingSmall>
        <div>We&apos;re working on fixing the problem. Try again later.</div>
      </div>
      <WoahNoIcon />
    </Box>
  </Box>
);
